import { _s, _t } from '@/locale';
import type { SearchKeywordWithSlug } from './../types/SearchKeywords.types';

const tBase2 = (key: string) => _s(`features.mega-menu.modules.Category.constants.${key}`);

export const SEARCH_KEYWORDS = [
  { translation: tBase2('Akne'), label: 'Akne', slug: 'akne' },
  { translation: tBase2('Aknebehandling'), label: 'Aknebehandling', slug: 'aknebehandling' },
  { translation: tBase2('Akrylnaglar'), label: 'Akrylnaglar', slug: 'akrylnaglar' },
  { translation: tBase2('Akupressur'), label: 'Akupressur', slug: 'akupressur' },
  { translation: tBase2('Akupunktur'), label: 'Akupunktur', slug: 'akupunktur' },
  { translation: tBase2('Alternativmedicin'), label: 'Alternativmedicin', slug: 'alternativmedicin' },
  { translation: tBase2('Andningsmassage'), label: 'Andningsmassage', slug: 'andningsmassage' },
  { translation: tBase2('Ansiktsbehandling'), label: 'Ansiktsbehandling', slug: 'ansiktsbehandling' },
  {
    translation: tBase2('Ansiktsbehandling djuprengörande'),
    label: 'Ansiktsbehandling djuprengörande',
    slug: 'ansiktsbehandling-djuprengorande',
  },
  {
    translation: tBase2('Ansiktslyft utan kirurgi'),
    label: 'Ansiktslyft utan kirurgi',
    slug: 'ansiktslyft-utan-kirurgi',
  },
  { translation: tBase2('Ansiktsmassage'), label: 'Ansiktsmassage', slug: 'ansiktsmassage' },
  { translation: tBase2('Aromamassage'), label: 'Aromamassage', slug: 'aromamassage' },
  { translation: tBase2('Ashtanga Yoga'), label: 'Ashtanga Yoga', slug: 'ashtanga-yoga' },
  { translation: _t('Astrologi'), label: 'Astrologi', slug: 'astrologi' },
  { translation: tBase2('Ayurveda'), label: 'Ayurveda', slug: 'ayurveda' },
  { translation: tBase2('Ayurvedisk Massage'), label: 'Ayurvedisk Massage', slug: 'ayurvedisk-massage' },
  { translation: tBase2('Babylights'), label: 'Babylights', slug: 'babylights' },
  { translation: tBase2('Balayage'), label: 'Balayage', slug: 'balayage' },
  { translation: tBase2('Bambumassage'), label: 'Bambumassage', slug: 'bambumassage' },
  { translation: tBase2('Barber'), label: 'Barber', slug: 'barber' },
  { translation: tBase2('Barberare'), label: 'Barberare', slug: 'barberare' },
  { translation: tBase2('Barnklippning'), label: 'Barnklippning', slug: 'barnklippning' },
  { translation: tBase2('BIAB'), label: 'BIAB', slug: 'biab' },
  { translation: _t('Biltvätt'), label: 'Biltvätt', slug: 'biltvatt' },
  { translation: _t('Bilvård'), label: 'Bilvård', slug: 'bilvard' },
  { translation: _t('Bioresonansterapi'), label: 'Bioresonansterapi', slug: 'bioresonansterapi' },
  { translation: tBase2('Blowout'), label: 'Blowout', slug: 'blowout' },
  { translation: tBase2('Borttagning'), label: 'Borttagning', slug: 'borttagning' },
  { translation: _t('Botox'), label: 'Botox', slug: 'botox' },
  { translation: tBase2('Bottenfärg'), label: 'Bottenfärg', slug: 'bottenfarg' },
  { translation: tBase2('Browlift'), label: 'Browlift', slug: 'browlift' },
  { translation: tBase2('Brynformning'), label: 'Brynformning', slug: 'brynformning' },
  { translation: tBase2('Brynfärgning'), label: 'Brynfärgning', slug: 'brynfargning' },
  { translation: tBase2('Brynplockning'), label: 'Brynplockning', slug: 'brynplockning' },
  { translation: tBase2('Bröllopsuppsättning'), label: 'Bröllopsuppsättning', slug: 'brollopsuppsattning' },
  { translation: tBase2('Celluliter'), label: 'Celluliter', slug: 'celluliter' },
  { translation: tBase2('Coachning'), label: 'Coachning', slug: 'coachning' },
  { translation: tBase2('Color correction'), label: 'Color correction', slug: 'color-correction' },
  { translation: tBase2('Cryoterapi'), label: 'Cryoterapi', slug: 'cryoterapi' },
  { translation: tBase2('Damklippning'), label: 'Damklippning', slug: 'damklippning' },
  { translation: tBase2('Dermapen'), label: 'Dermapen', slug: 'dermapen' },
  { translation: tBase2('Diamantslipning'), label: 'Diamantslipning', slug: 'diamantslipning' },
  { translation: _t('Djurvård'), label: 'Djurvård', slug: 'djurvard' },
  { translation: _t('Däckbyte'), label: 'Däckbyte', slug: 'dackbyte' },
  { translation: _t('Däckhotell'), label: 'Däckhotell', slug: 'dackhotell' },
  { translation: _t('Däckverkstad'), label: 'Däckverkstad', slug: 'dackverkstad' },
  { translation: tBase2('Enzympeeling'), label: 'Enzympeeling', slug: 'enzympeeling' },
  { translation: tBase2('Estetisk fotvård'), label: 'Estetisk fotvård', slug: 'estetisk-fotvard' },
  { translation: tBase2('Extensions'), label: 'Extensions', slug: 'extensions' },
  {
    translation: tBase2('Extensions borttagning'),
    label: 'Extensions borttagning',
    slug: 'extensions-borttagning',
  },
  { translation: tBase2('Eyeliner-tatuering'), label: 'Eyeliner-tatuering', slug: 'eyeliner-tatuering' },
  { translation: tBase2('Face framing'), label: 'Face framing', slug: 'face-framing' },
  { translation: tBase2('Faceliftmassage'), label: 'Faceliftmassage', slug: 'faceliftmassage' },
  { translation: tBase2('Fet hårbotten'), label: 'Fet hårbotten', slug: 'fet-harbotten' },
  { translation: _t('Fettfrysning'), label: 'Fettfrysning', slug: 'fettfrysning' },
  { translation: tBase2('Fettreducering'), label: 'Fettreducering', slug: 'fettreducering' },
  { translation: tBase2('Fibromassage'), label: 'Fibromassage', slug: 'fibromassage' },
  { translation: tBase2('Fillers'), label: 'Fillers', slug: 'fillers' },
  { translation: tBase2('Fotmassage'), label: 'Fotmassage', slug: 'fotmassage' },
  { translation: _t('Fotografering'), label: 'Fotografering', slug: 'fotografering' },
  { translation: tBase2('Fotsvamp'), label: 'Fotsvamp', slug: 'fotsvamp' },
  { translation: tBase2('Fotvård'), label: 'Fotvård', slug: 'fotvard' },
  { translation: tBase2('Fransar'), label: 'Fransar', slug: 'fransar' },
  { translation: tBase2('Fransborttagning'), label: 'Fransborttagning', slug: 'fransborttagning' },
  { translation: tBase2('Fransfärgning'), label: 'Fransfärgning', slug: 'fransfargning' },
  { translation: tBase2('Fransförlängning'), label: 'Fransförlängning', slug: 'fransforlangning' },
  {
    translation: tBase2('Fransförlängning Megavolym'),
    label: 'Fransförlängning Megavolym',
    slug: 'fransforlangning-megavolym',
  },
  {
    translation: tBase2('Fransförlängning Volym'),
    label: 'Fransförlängning Volym',
    slug: 'fransforlangning-volym',
  },
  { translation: tBase2('Fransk manikyr'), label: 'Fransk manikyr', slug: 'fransk-manikyr' },
  { translation: tBase2('Fransrengöring'), label: 'Fransrengöring', slug: 'fransrengoring' },
  { translation: tBase2('Frekvensterapi'), label: 'Frekvensterapi', slug: 'frekvensterapi' },
  { translation: tBase2('Friskvård'), label: 'Friskvård', slug: 'friskvard' },
  { translation: tBase2('Friskvårdsmassage'), label: 'Friskvårdsmassage', slug: 'friskvardsmassage' },
  { translation: tBase2('Frisör'), label: 'Frisör', slug: 'frisor' },
  { translation: tBase2('Funktionsanalys'), label: 'Funktionsanalys', slug: 'funktionsanalys' },
  { translation: _t('Fysioterapi'), label: 'Fysioterapi', slug: 'fysioterapi' },
  { translation: tBase2('Färgning'), label: 'Färgning', slug: 'fargning' },
  { translation: tBase2('Föning'), label: 'Föning', slug: 'foning' },
  { translation: tBase2('Gel naglar'), label: 'Gel naglar', slug: 'gel-naglar' },
  { translation: tBase2('Gele naglar'), label: 'Gele naglar', slug: 'gele-naglar' },
  { translation: tBase2('Gelenaglar'), label: 'Gelenaglar', slug: 'gelenaglar' },
  { translation: tBase2('Gellack'), label: 'Gellack', slug: 'gellack' },
  {
    translation: tBase2('Gellack med förstärkning'),
    label: 'Gellack med förstärkning',
    slug: 'gellack-med-forstarkning',
  },
  { translation: _t('Golf'), label: 'Golf', slug: 'golf' },
  { translation: _t('Graviditet'), label: 'Graviditet', slug: 'graviditet' },
  { translation: tBase2('Gravidmassage'), label: 'Gravidmassage', slug: 'gravidmassage' },
  { translation: tBase2('Gravidyoga'), label: 'Gravidyoga', slug: 'gravidyoga' },
  { translation: tBase2('Gruppträning'), label: 'Gruppträning', slug: 'grupptraning' },
  { translation: tBase2('Gua Sha-massage'), label: 'Gua Sha-massage', slug: 'gua-sha-massage' },
  { translation: tBase2('Hatha Yoga'), label: 'Hatha Yoga', slug: 'hatha-yoga' },
  { translation: tBase2('Headspa'), label: 'Headspa', slug: 'headspa' },
  { translation: tBase2('Healing'), label: 'Healing', slug: 'healing' },
  { translation: tBase2('Herrklippning'), label: 'Herrklippning', slug: 'herrklippning' },
  { translation: tBase2('HIFU'), label: 'HIFU', slug: 'hifu' },
  { translation: tBase2('Hollywood Peel'), label: 'Hollywood Peel', slug: 'hollywood-peel' },
  { translation: tBase2('Hot Stone Massage'), label: 'Hot Stone Massage', slug: 'hot-stone-massage' },
  { translation: tBase2('Hot yoga'), label: 'Hot yoga', slug: 'hot-yoga' },
  { translation: tBase2('Hudföryngring'), label: 'Hudföryngring', slug: 'hudforyngring' },
  { translation: tBase2('Huduppstramning'), label: 'Huduppstramning', slug: 'huduppstramning' },
  { translation: tBase2('Hudvård'), label: 'Hudvård', slug: 'hudvard' },
  { translation: _t('Hund'), label: 'Hund', slug: 'hund' },
  { translation: _t('Hundfrisör'), label: 'Hundfrisör', slug: 'hundfrisor' },
  { translation: tBase2('Hyaluronsyra'), label: 'Hyaluronsyra', slug: 'hyaluronsyra' },
  { translation: tBase2('Hyperhidros'), label: 'Hyperhidros', slug: 'hyperhidros' },
  { translation: tBase2('Hypnos'), label: 'Hypnos', slug: 'hypnos' },
  { translation: tBase2('Hårborttagning'), label: 'Hårborttagning', slug: 'harborttagning' },
  { translation: tBase2('Hårbottenbehandling'), label: 'Hårbottenbehandling', slug: 'harbottenbehandling' },
  { translation: tBase2('Hårförlängning'), label: 'Hårförlängning', slug: 'harforlangning' },
  { translation: tBase2('Hårvård'), label: 'Hårvård', slug: 'harvard' },
  { translation: tBase2('Hälsa'), label: 'Hälsa', slug: 'halsa' },
  { translation: tBase2('Hälsprickor'), label: 'Hälsprickor', slug: 'halsprickor' },
  { translation: _t('Häst'), label: 'Häst', slug: 'hast' },
  { translation: tBase2('Idrottsmassage'), label: 'Idrottsmassage', slug: 'idrottsmassage' },
  {
    translation: _t('Injektionsbehandlingar'),
    label: 'Injektionsbehandlingar',
    slug: 'injektionsbehandlingar',
  },
  { translation: _t('Inredning'), label: 'Inredning', slug: 'inredning' },
  { translation: tBase2('IPL'), label: 'IPL', slug: 'ipl' },
  { translation: tBase2('IPL hårborttagning'), label: 'IPL hårborttagning', slug: 'ipl-harborttagning' },
  { translation: tBase2('IR-massage'), label: 'IR-massage', slug: 'ir-massage' },
  { translation: tBase2('Japansk massage'), label: 'Japansk massage', slug: 'japansk-massage' },
  { translation: tBase2('K18'), label: 'K18', slug: 'k18' },
  { translation: _t('Katt'), label: 'Katt', slug: 'katt' },
  { translation: tBase2('Katun fransar'), label: 'Katun fransar', slug: 'katun-fransar' },
  { translation: tBase2('Kemisk peeling'), label: 'Kemisk peeling', slug: 'kemisk-peeling' },
  { translation: tBase2('Keratin'), label: 'Keratin', slug: 'keratin' },
  { translation: tBase2('Keratinbehandling'), label: 'Keratinbehandling', slug: 'keratinbehandling' },
  { translation: tBase2('Kinesiologi'), label: 'Kinesiologi', slug: 'kinesiologi' },
  { translation: tBase2('Kinesisk medicin'), label: 'Kinesisk medicin', slug: 'kinesisk-medicin' },
  { translation: tBase2('Kiropraktik'), label: 'Kiropraktik', slug: 'kiropraktik' },
  { translation: tBase2('Klangmassage'), label: 'Klangmassage', slug: 'klangmassage' },
  { translation: tBase2('Klassisk massage'), label: 'Klassisk massage', slug: 'klassisk-massage' },
  { translation: tBase2('Klippning'), label: 'Klippning', slug: 'klippning' },
  { translation: tBase2('Klippning & Slingor'), label: 'Klippning & Slingor', slug: 'klippning-slingor' },
  { translation: tBase2('Klippning ungdom'), label: 'Klippning ungdom', slug: 'klippning-ungdom' },
  { translation: _t('Konsultation'), label: 'Konsultation', slug: 'konsultation' },
  { translation: tBase2('Koppningsmassage'), label: 'Koppningsmassage', slug: 'koppningsmassage' },
  { translation: tBase2('Kosmetisk tatuering'), label: 'Kosmetisk tatuering', slug: 'kosmetisk-tatuering' },
  { translation: tBase2('Kostrådgivning'), label: 'Kostrådgivning', slug: 'kostradgivning' },
  { translation: _t('Kraniosakral terapi'), label: 'Kraniosakral terapi', slug: 'kraniosakral-terapi' },
  { translation: tBase2('Kroppsinpackning'), label: 'Kroppsinpackning', slug: 'kroppsinpackning' },
  { translation: tBase2('Kroppspeeling'), label: 'Kroppspeeling', slug: 'kroppspeeling' },
  { translation: _t('Kroppsterapeuter'), label: 'Kroppsterapeuter', slug: 'kroppsterapeuter' },
  { translation: _t('Kurser'), label: 'Kurser', slug: 'kurser' },
  { translation: tBase2('Käkledsbehandling'), label: 'Käkledsbehandling', slug: 'kakledsbehandling' },
  { translation: tBase2('Kärlbehandling'), label: 'Kärlbehandling', slug: 'karlbehandling' },
  { translation: tBase2('Laserbehandling'), label: 'Laserbehandling', slug: 'laserbehandling' },
  { translation: _t('Lash lift'), label: 'Lash lift', slug: 'lash-lift' },
  { translation: tBase2('Lashlift'), label: 'Lashlift', slug: 'lashlift' },
  { translation: tBase2('Lashlift Keratin'), label: 'Lashlift Keratin', slug: 'lashlift-keratin' },
  { translation: tBase2('LED-ljusterapi'), label: 'LED-ljusterapi', slug: 'led-ljusterapi' },
  { translation: _t('Ledarskap'), label: 'Ledarskap', slug: 'ledarskap' },
  { translation: tBase2('Liktornar'), label: 'Liktornar', slug: 'liktornar' },
  { translation: tBase2('LPG'), label: 'LPG', slug: 'lpg' },
  { translation: tBase2('LPG-behandling'), label: 'LPG-behandling', slug: 'lpg-behandling' },
  { translation: tBase2('LPG-massage'), label: 'LPG-massage', slug: 'lpg-massage' },
  { translation: tBase2('Luggklippning'), label: 'Luggklippning', slug: 'luggklippning' },
  { translation: tBase2('Lymfmassage'), label: 'Lymfmassage', slug: 'lymfmassage' },
  { translation: _t('Läkare'), label: 'Läkare', slug: 'lakare' },
  { translation: tBase2('Läpptatuering'), label: 'Läpptatuering', slug: 'lapptatuering' },
  { translation: tBase2('Makeup'), label: 'Makeup', slug: 'makeup' },
  { translation: tBase2('Manikyr'), label: 'Manikyr', slug: 'manikyr' },
  { translation: tBase2('Manikyr & Pedikyr'), label: 'Manikyr & Pedikyr', slug: 'manikyr-pedikyr' },
  { translation: tBase2('Massage'), label: 'Massage', slug: 'massage' },
  { translation: tBase2('Medial vägledning'), label: 'Medial vägledning', slug: 'medial-vagledning' },
  { translation: tBase2('Medicinsk fotvård'), label: 'Medicinsk fotvård', slug: 'medicinsk-fotvard' },
  { translation: tBase2('Medicinsk massage'), label: 'Medicinsk massage', slug: 'medicinsk-massage' },
  { translation: tBase2('Meditation'), label: 'Meditation', slug: 'meditation' },
  { translation: tBase2('Medium'), label: 'Medium', slug: 'medium' },
  { translation: tBase2('Megavolymfransar'), label: 'Megavolymfransar', slug: 'megavolymfransar' },
  { translation: tBase2('Melasma'), label: 'Melasma', slug: 'melasma' },
  { translation: tBase2('Mesoterapi'), label: 'Mesoterapi', slug: 'mesoterapi' },
  { translation: tBase2('Microblading'), label: 'Microblading', slug: 'microblading' },
  { translation: tBase2('Microneedling'), label: 'Microneedling', slug: 'microneedling' },
  { translation: tBase2('MicroPen'), label: 'MicroPen', slug: 'micropen' },
  { translation: tBase2('Microshading'), label: 'Microshading', slug: 'microshading' },
  { translation: tBase2('Mixfransar'), label: 'Mixfransar', slug: 'mixfransar' },
  { translation: tBase2('Nagelförlängning'), label: 'Nagelförlängning', slug: 'nagelforlangning' },
  {
    translation: tBase2('Nagelförlängning akryl'),
    label: 'Nagelförlängning akryl',
    slug: 'nagelforlangning-akryl',
  },
  { translation: tBase2('Nagelförlängning gelé'), label: 'Nagelförlängning gelé', slug: 'nagelforlangning-gele' },
  {
    translation: tBase2('Nagelförlängning glasfiber'),
    label: 'Nagelförlängning glasfiber',
    slug: 'nagelforlangning-glasfiber',
  },
  {
    translation: tBase2('Nagelförlängning silke'),
    label: 'Nagelförlängning silke',
    slug: 'nagelforlangning-silke',
  },
  { translation: tBase2('Nagelförstärkning'), label: 'Nagelförstärkning', slug: 'nagelforstarkning' },
  { translation: tBase2('Nagelklippning'), label: 'Nagelklippning', slug: 'nagelklippning' },
  { translation: tBase2('Nagelsvamp'), label: 'Nagelsvamp', slug: 'nagelsvamp' },
  { translation: tBase2('Nageltrång'), label: 'Nageltrång', slug: 'nageltrang' },
  { translation: tBase2('Nagelvård'), label: 'Nagelvård', slug: 'nagelvard' },
  { translation: tBase2('Naglar'), label: 'Naglar', slug: 'naglar' },
  { translation: tBase2('Naglar borttagning'), label: 'Naglar borttagning', slug: 'naglar-borttagning' },
  { translation: tBase2('Naglar reparation'), label: 'Naglar reparation', slug: 'naglar-reparation' },
  { translation: tBase2('Naprapati'), label: 'Naprapati', slug: 'naprapati' },
  { translation: _t('Naturmedicin'), label: 'Naturmedicin', slug: 'naturmedicin' },
  { translation: tBase2('Navelpiercing'), label: 'Navelpiercing', slug: 'navelpiercing' },
  { translation: tBase2('NBE-massage'), label: 'NBE-massage', slug: 'nbe-massage' },
  { translation: tBase2('Ny frisyr'), label: 'Ny frisyr', slug: 'ny-frisyr' },
  { translation: _t('Näringsterapi'), label: 'Näringsterapi', slug: 'naringsterapi' },
  { translation: tBase2('Olaplex'), label: 'Olaplex', slug: 'olaplex' },
  { translation: tBase2('Olaplexbehandling'), label: 'Olaplexbehandling', slug: 'olaplexbehandling' },
  { translation: tBase2('Ombre'), label: 'Ombre', slug: 'ombre' },
  { translation: tBase2('Ombre brows'), label: 'Ombre brows', slug: 'ombre-brows' },
  { translation: tBase2('Ombre naglar'), label: 'Ombre naglar', slug: 'ombre-naglar' },
  { translation: tBase2('Optiker'), label: 'Optiker', slug: 'optiker' },
  { translation: tBase2('Ortobionomi'), label: 'Ortobionomi', slug: 'ortobionomi' },
  { translation: tBase2('Ortopedi'), label: 'Ortopedi', slug: 'ortopedi' },
  { translation: tBase2('Osteopati'), label: 'Osteopati', slug: 'osteopati' },
  { translation: tBase2('Paraffinbehandling'), label: 'Paraffinbehandling', slug: 'paraffinbehandling' },
  { translation: tBase2('Pedikyr'), label: 'Pedikyr', slug: 'pedikyr' },
  { translation: tBase2('Pensionärklippning'), label: 'Pensionärklippning', slug: 'pensionarklippning' },
  { translation: tBase2('Permanent'), label: 'Permanent', slug: 'permanent' },
  {
    translation: tBase2('Permanent hårborttagning'),
    label: 'Permanent hårborttagning',
    slug: 'permanent-harborttagning',
  },
  {
    translation: tBase2('Permanent ögonbrynsmakeup'),
    label: 'Permanent ögonbrynsmakeup',
    slug: 'permanent-ogonbrynsmakeup',
  },
  { translation: tBase2('Personal shopper'), label: 'Personal shopper', slug: 'personal-shopper' },
  { translation: tBase2('Personlig tränare'), label: 'Personlig tränare', slug: 'personlig-tranare' },
  { translation: _t('Personlig träning'), label: 'Personlig träning', slug: 'personlig-traning' },
  { translation: tBase2('Picolaser'), label: 'Picolaser', slug: 'picolaser' },
  { translation: tBase2('Piercing'), label: 'Piercing', slug: 'piercing' },
  { translation: tBase2('Pigmentbehandling'), label: 'Pigmentbehandling', slug: 'pigmentbehandling' },
  { translation: tBase2('Pigmentfläckar'), label: 'Pigmentfläckar', slug: 'pigmentflackar' },
  { translation: tBase2('Plastikkirurgi'), label: 'Plastikkirurgi', slug: 'plastikkirurgi' },
  { translation: tBase2('Powder brows'), label: 'Powder brows', slug: 'powder-brows' },
  { translation: tBase2('Power Yoga'), label: 'Power Yoga', slug: 'power-yoga' },
  { translation: _t('Profylax'), label: 'Profylax', slug: 'profylax' },
  { translation: tBase2('PRP'), label: 'PRP', slug: 'prp' },
  {
    translation: tBase2('PRP (Platelet Rich Plasma)'),
    label: 'PRP (Platelet Rich Plasma)',
    slug: 'prp-platelet-rich-plasma',
  },
  { translation: tBase2('PRX-T33'), label: 'PRX-T33', slug: 'prx-t33' },
  { translation: tBase2('Psoriasis'), label: 'Psoriasis', slug: 'psoriasis' },
  { translation: _t('Psykolog'), label: 'Psykolog', slug: 'psykolog' },
  { translation: tBase2('PT'), label: 'PT', slug: 'pt' },
  { translation: _t('Qigong'), label: 'Qigong', slug: 'qigong' },
  { translation: tBase2('Radiofrekvens'), label: 'Radiofrekvens', slug: 'radiofrekvens' },
  { translation: tBase2('Rakning'), label: 'Rakning', slug: 'rakning' },
  { translation: tBase2('Reflexologi'), label: 'Reflexologi', slug: 'reflexologi' },
  { translation: tBase2('Regndroppsmassage'), label: 'Regndroppsmassage', slug: 'regndroppsmassage' },
  { translation: tBase2('Reiki'), label: 'Reiki', slug: 'reiki' },
  { translation: tBase2('Reiki massage'), label: 'Reiki massage', slug: 'reiki-massage' },
  { translation: tBase2('Reikihealing'), label: 'Reikihealing', slug: 'reikihealing' },
  { translation: tBase2('Reparation'), label: 'Reparation', slug: 'reparation' },
  { translation: tBase2('Restorative Yoga'), label: 'Restorative Yoga', slug: 'restorative-yoga' },
  { translation: tBase2('Rosacea'), label: 'Rosacea', slug: 'rosacea' },
  { translation: tBase2('Rosaceabehandling'), label: 'Rosaceabehandling', slug: 'rosaceabehandling' },
  { translation: tBase2('Rosenmetoden'), label: 'Rosenmetoden', slug: 'rosenmetoden' },
  { translation: tBase2('Ryggmassage'), label: 'Ryggmassage', slug: 'ryggmassage' },
  { translation: _t('Rådgivning'), label: 'Rådgivning', slug: 'radgivning' },
  { translation: tBase2('Samtalsterapi'), label: 'Samtalsterapi', slug: 'samtalsterapi' },
  { translation: tBase2('Senioryoga'), label: 'Senioryoga', slug: 'senioryoga' },
  { translation: tBase2('Shiatsu'), label: 'Shiatsu', slug: 'shiatsu' },
  { translation: tBase2('Singel fransar'), label: 'Singel fransar', slug: 'singel-fransar' },
  { translation: tBase2('Singelfransar'), label: 'Singelfransar', slug: 'singelfransar' },
  { translation: tBase2('Sjukgymnastik'), label: 'Sjukgymnastik', slug: 'sjukgymnastik' },
  { translation: tBase2('Skalpmassage'), label: 'Skalpmassage', slug: 'skalpmassage' },
  { translation: tBase2('Skinbooster'), label: 'Skinbooster', slug: 'skinbooster' },
  { translation: tBase2('Sklerosering'), label: 'Sklerosering', slug: 'sklerosering' },
  { translation: tBase2('Skoinlägg'), label: 'Skoinlägg', slug: 'skoinlagg' },
  { translation: tBase2('Skägg'), label: 'Skägg', slug: 'skagg' },
  { translation: tBase2('Skäggfärgning'), label: 'Skäggfärgning', slug: 'skaggfargning' },
  { translation: tBase2('Skäggklippning'), label: 'Skäggklippning', slug: 'skaggklippning' },
  { translation: tBase2('Skäggtrimmning'), label: 'Skäggtrimmning', slug: 'skaggtrimmning' },
  { translation: _t('Skäggvård'), label: 'Skäggvård', slug: 'skaggvard' },
  { translation: tBase2('Skönhet'), label: 'Skönhet', slug: 'skonhet' },
  { translation: tBase2('Slingor'), label: 'Slingor', slug: 'slingor' },
  { translation: tBase2('Sockring'), label: 'Sockring', slug: 'sockring' },
  { translation: tBase2('Spa'), label: 'Spa', slug: 'spa' },
  { translation: tBase2('Spa manikyr & pedikyr'), label: 'Spa manikyr & pedikyr', slug: 'spa-manikyr-pedikyr' },
  { translation: tBase2('Spa-manikyr'), label: 'Spa-manikyr', slug: 'spa-manikyr' },
  { translation: tBase2('Spa-pedikyr'), label: 'Spa-pedikyr', slug: 'spa-pedikyr' },
  { translation: _t('Sport'), label: 'Sport', slug: 'sport' },
  { translation: tBase2('Spraytan'), label: 'Spraytan', slug: 'spraytan' },
  { translation: tBase2('Stylist'), label: 'Stylist', slug: 'stylist' },
  { translation: _t('Städning'), label: 'Städning', slug: 'stadning' },
  { translation: _t('Städservice'), label: 'Städservice', slug: 'stadservice' },
  { translation: tBase2('Sugaring'), label: 'Sugaring', slug: 'sugaring' },
  { translation: tBase2('Svensk massage'), label: 'Svensk massage', slug: 'svensk-massage' },
  { translation: tBase2('Svettbehandling'), label: 'Svettbehandling', slug: 'svettbehandling' },
  { translation: tBase2('Taktil massage'), label: 'Taktil massage', slug: 'taktil-massage' },
  { translation: tBase2('Tandblekning'), label: 'Tandblekning', slug: 'tandblekning' },
  { translation: tBase2('Tandläkare'), label: 'Tandläkare', slug: 'tandlakare' },
  { translation: _t('Tandvård'), label: 'Tandvård', slug: 'tandvard' },
  { translation: tBase2('Tatuering'), label: 'Tatuering', slug: 'tatuering' },
  { translation: tBase2('Tatueringsborttagning'), label: 'Tatueringsborttagning', slug: 'tatueringsborttagning' },
  { translation: tBase2('Terapi'), label: 'Terapi', slug: 'terapi' },
  { translation: tBase2('Thaimassage'), label: 'Thaimassage', slug: 'thaimassage' },
  { translation: tBase2('Toning'), label: 'Toning', slug: 'toning' },
  { translation: tBase2('Torr hårbotten'), label: 'Torr hårbotten', slug: 'torr-harbotten' },
  { translation: tBase2('Torrborstning'), label: 'Torrborstning', slug: 'torrborstning' },
  { translation: tBase2('Triggerpunktsmassage'), label: 'Triggerpunktsmassage', slug: 'triggerpunktsmassage' },
  { translation: tBase2('Trådning'), label: 'Trådning', slug: 'tradning' },
  { translation: tBase2('Träning'), label: 'Träning', slug: 'traning' },
  { translation: tBase2('Tuina-massage'), label: 'Tuina-massage', slug: 'tuina-massage' },
  { translation: tBase2('Tvätt & Fön'), label: 'Tvätt & Fön', slug: 'tvatt-fon' },
  { translation: _t('Utbildning'), label: 'Utbildning', slug: 'utbildning' },
  { translation: _t('Utbildningar'), label: 'Utbildningar', slug: 'utbildningar' },
  { translation: tBase2('Vaccination'), label: 'Vaccination', slug: 'vaccination' },
  { translation: _s('Beauty&Health'), label: 'Vad', slug: 'vad' },
  { translation: tBase2('Vampyrbehandling'), label: 'Vampyrbehandling', slug: 'vampyrbehandling' },
  { translation: tBase2('Vaxning'), label: 'Vaxning', slug: 'vaxning' },
  { translation: tBase2('Vaxning brasiliansk'), label: 'Vaxning brasiliansk', slug: 'vaxning-brasiliansk' },
  { translation: _t('Verkstad'), label: 'Verkstad', slug: 'verkstad' },
  { translation: tBase2('Veterinär'), label: 'Veterinär', slug: 'veterinar' },
  { translation: _t('Veterinärer'), label: 'Veterinärer', slug: 'veterinarer' },
  { translation: tBase2('Vibrationsmassage'), label: 'Vibrationsmassage', slug: 'vibrationsmassage' },
  { translation: tBase2('Vinyasa Yoga'), label: 'Vinyasa Yoga', slug: 'vinyasa-yoga' },
  { translation: tBase2('Volymfransar'), label: 'Volymfransar', slug: 'volymfransar' },
  { translation: tBase2('Vårtor'), label: 'Vårtor', slug: 'vartor' },
  { translation: tBase2('Yin Yoga'), label: 'Yin Yoga', slug: 'yin-yoga' },
  { translation: tBase2('Yoga'), label: 'Yoga', slug: 'yoga' },
  { translation: tBase2('Yoga Nidra'), label: 'Yoga Nidra', slug: 'yoga-nidra' },
  { translation: tBase2('Yogamassage'), label: 'Yogamassage', slug: 'yogamassage' },
  { translation: tBase2('Zonterapi'), label: 'Zonterapi', slug: 'zonterapi' },
  { translation: tBase2('Zumba'), label: 'Zumba', slug: 'zumba' },
  { translation: tBase2('Ögonbryn'), label: 'Ögonbryn', slug: 'ogonbryn' },
  { translation: tBase2('Ögonbrynsfärg'), label: 'Ögonbrynsfärg', slug: 'ogonbrynsfarg' },
  { translation: tBase2('Ögonbrynstatuering'), label: 'Ögonbrynstatuering', slug: 'ogonbrynstatuering' },
  { translation: tBase2('Ögonfransar'), label: 'Ögonfransar', slug: 'ogonfransar' },
  { translation: tBase2('Ögonfransförlängning'), label: 'Ögonfransförlängning', slug: 'ogonfransforlangning' },
] as const;

export type SearchKeywordSlug = (typeof SEARCH_KEYWORDS)[number]['slug'];

export const SEARCH_KEYWORDS_OBJECT = SEARCH_KEYWORDS.reduce((map, item) => {
  map[item.slug] = item;
  return map;
}, {} as Record<SearchKeywordSlug, SearchKeywordWithSlug>);
